<tcm-main-search-layout titleKey="Screens.WorkQueueNotes.Search.Title"
                        [useExport]="false"
                        [useGlobalSearch]="false"
                        [isLoading]="isLoading"
                        [(searchTerm)]="searchTerm">

  <ng-container *ngIf="viewModel" after-export-area>
    <waf-select-input name="clinicId"
                      class="control-left-label"
                      [label]="'Common.SearchColumnsAndDetailsFields.Clinic' | translate"
                      [(ngModel)]="clinicId"
                      (ngModelChange)="onClinicChanged()"
                      [options]="activeClinicOptions"
                      [allowClear]="false"></waf-select-input>
    <waf-select-input id="assignedUserId"
                      name="assignedUserId"
                      class="control-left-label assigned-user-control"
                      [label]="'Common.SearchColumnsAndDetailsFields.AssignedUser' | translate"
                      [(ngModel)]="assignedUserId"
                      (ngModelChange)="onAssignedUserChanged()"
                      [options]="viewModel.assignedUserInitOptions"
                      [optionsLoaderFunc]="getUserOptionsFunc"
                      [required]="!specialActionPermissions.allowToSeeClinicWorkQueues.canExecute"></waf-select-input>
  </ng-container>

  <ng-container results-area *ngIf="viewModel?.records">
    <search-results [search]="searchInstance">
      <table class="search-table linked-collection-table">
        <thead>
          <tr>
            <th table-header key="AssignedUserEmail" [label]="'Common.SearchColumnsAndDetailsFields.User' | translate"
                [sortModel]="requestModel.sorting" (sort)="onSortChanged()"></th>
            <th table-header key="PatientName" [label]="'Common.SearchColumnsAndDetailsFields.Patient' | translate"
                [sortModel]="requestModel.sorting" (sort)="onSortChanged()"></th>
            <th table-header key="Type" [label]="'Common.SearchColumnsAndDetailsFields.Type' | translate"
                [sortModel]="requestModel.sorting" (sort)="onSortChanged()"></th>
            <th table-header key="Subject" [label]="'Screens.WorkQueueNotes.Search.Columns.Subject' | translate"
                [sortModel]="requestModel.sorting" (sort)="onSortChanged()"></th>
            <th table-header key="Status" [label]="'Common.SearchColumnsAndDetailsFields.Status' | translate"
                [sortModel]="requestModel.sorting" (sort)="onSortChanged()"></th>
            <th table-header key="FollowUp" [label]="'Screens.WorkQueueNotes.Search.Columns.FollowUp' | translate"
                [sortModel]="requestModel.sorting" (sort)="onSortChanged()"></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let note of viewModel.records; let index=index; let odd=odd; let even=even;"
              [ngClass]="{'odd': odd, 'even':even}"
              [routerLink]="['/work-queues/notes/details', {mode: 'modal', size: 'lg'}]"
              [queryParams]="{id: note.id}"
              class="clickable-row">
            <td>{{note.assignedUserEmail}}</td>
            <td>{{note.patientName}}</td>
            <td>{{noteTypeTranslations[note.type]}}</td>
            <td>{{note.subject}}</td>
            <td>{{noteStatusTranslations[note.status]}}</td>
            <td>{{note.followUp | wafShortDate}}</td>
            <td class="table-actions-cell">
              <button *ngIf="note.patientId"
                      (click)="goToButtonClick($event, '/patients/details', {id: note.patientId})"
                      class="btn btn-complete me-3">
                {{'Screens.WorkQueueNotes.Search.Actions.GoToPatient' | translate}}
              </button>
              <button *ngIf="note.appointmentId"
                      (click)="goToButtonClick($event, '/scheduling/appointments/details', {id: note.appointmentId})"
                      class="btn btn-complete me-3">
                {{'Screens.WorkQueueNotes.Search.Actions.GoToAppointment' | translate}}
              </button>
              <button *ngIf="note.salesOrderId"
                      (click)="goToButtonClick($event, '/sales-orders/details', {id: note.salesOrderId})"
                      class="btn btn-complete me-3">
                {{'Screens.WorkQueueNotes.Search.Actions.GoToSalesOrder' | translate}}
              </button>
              <button *ngIf="note.claimId"
                      (click)="goToButtonClick($event, '/claims/claims/details', {id: note.claimId})"
                      class="btn btn-complete me-3">
                {{'Screens.WorkQueueNotes.Search.Actions.GoToClaim' | translate}}
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <search-paging [search]="searchInstance"></search-paging>
    </search-results>
  </ng-container>

  <ng-container *ngIf="viewModel" right-sidebar-area>
    <advanced-search (submit)="onFilterSubmitted()" (clear)="onFilterCleared()">
      <!-- <waf-select-input name="clinicId"
                      [label]="'Common.SearchColumnsAndDetailsFields.Clinic' | translate"
                      [(ngModel)]="requestModel.clinicId"
                      [options]="viewModel.clinicOptions"
                      [allowClear]="true"></waf-select-input>
      <waf-select-input name="assignedUserId"
                      [label]="'Common.SearchColumnsAndDetailsFields.AssignedUser' | translate"
                      [(ngModel)]="requestModel.assignedUserId"                      
                      [optionsLoaderFunc]="getUserOptionsFunc"
                      [options]="viewModel.assignedUserInitOptions"
                      [allowClear]="true"
                      [required]="!specialActionPermissions.allowToSeeClinicWorkQueues.canExecute"></waf-select-input> -->
      <waf-select-input name="patientId"
                      [label]="'Common.SearchColumnsAndDetailsFields.Patient' | translate"
                      [(ngModel)]="requestModel.patientId"
                      [optionsLoaderFunc]="getPatientOptionsFunc"
                      [options]="viewModel.patientInitOptions"
                      [allowClear]="true"></waf-select-input>
      <waf-select-input name="statuses"
                      [label]="'Common.SearchColumnsAndDetailsFields.Status' | translate"
                      [(ngModel)]="requestModel.statuses"                      
                      [options]="noteStatusOptions"
                      [multiple]="true"
                      [allowClear]="true"></waf-select-input>
      <waf-date-input name="followUpDateFrom"
                      [label]="'Screens.WorkQueueNotes.Search.Filters.FollowUp' | translate"
                      [(ngModel)]="requestModel.followUpFromDate"                    
                      [lessThanOrEqualTo]="requestModel.followUpToDate"
                      comparisonType="Date"
                      [placeholder]="'Common.SearchColumnsAndDetailsFields.From' | translate"></waf-date-input>
      <waf-date-input name="followUpDateTo"
                      [label]="'Screens.WorkQueueNotes.Search.Filters.FollowUpFrom' | translate"
                      [(ngModel)]="requestModel.followUpToDate"
                      [greaterThanOrEqualTo]="requestModel.followUpFromDate"
                      comparisonType="Date"
                      [placeholder]="'Common.SearchColumnsAndDetailsFields.To' | translate"></waf-date-input>
    </advanced-search>
  </ng-container>
</tcm-main-search-layout>
